import { render, staticRenderFns } from "./DeprecationBanner.vue?vue&type=template&id=5cf01c13&"
import script from "./DeprecationBanner.vue?vue&type=script&lang=js&"
export * from "./DeprecationBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports